<template>
  <div class="d-flex align-center pa-5">
    <div class="grey--text mr-5">Item per page</div>
    <div style="width: 80px">
      <v-select
        color="primary"
        dense
        hide-details
        :items="sizes"
        :value="itemsPerPage"
        @change="$emit('change-items-per-page', $event)"
      />
    </div>
    <v-spacer />
    <span class="grey--text mr-4" data-test="pager-page">หน้า {{ page }}</span>
    <v-btn
      text
      small
      class="mr-2"
      :disabled="loading || !canPrevious"
      @click="$emit('previous')"
    >
      ก่อนหน้า
    </v-btn>
    <v-btn
      color="primary"
      small
      :disabled="loading || !canNext"
      @click="$emit('next')"
    >
      ถัดไป
    </v-btn>
  </div>
</template>

<script>
// Previous / next paging without page numbers or a total, like the car list.
export default {
  props: {
    page: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 20 },
    canPrevious: { type: Boolean, default: false },
    canNext: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data: () => ({ sizes: [10, 20, 50, 80, 110, 160, 200] }),
};
</script>
